(function($) {
  Drupal.behaviors.photos_fancybox = {
    attach: function (context, settings) {
      $('article.album .field--name-field-photos a').attr('rel', 'gallery');
      $('article.album .field--name-field-photos a').fancybox({
        'autoScale': true,
        'transitionIn': 'elastic',
        'transitionOut': 'elastic',
        'speedIn': 500,
        'speedOut': 300,
        'autoDimensions': true,
        'centerOnScroll': true,
        afterLoad: function(){
         this.title = $(this.element).find('img').attr('alt');
        }
      });
      // $('article.album .field--name-field-photos a').click(function(e) {
      //   $.fancybox.open({

      //   })
      //   console.log('asda');
      //   return false;
      // })
    }
  }

  $(document).ready(function(){
   var scroll_start = 0;
   var startchange = $('#highlighted');
   var offset = startchange.offset();
  if (startchange.length){
     $(document).scroll(function() {
        scroll_start = $(this).scrollTop();
        if(scroll_start > offset.top) {
            $(".navbar-default").addClass('has-solid-color');
         } else {
            $(".navbar-default").removeClass('has-solid-color');
         }
     });
    }
});
})(jQuery)
